import { useCallback, useState } from 'react';
import monitoring from '../common/libs/monitoring';
import useApiClient from './useApiClient';

/**
 * 検索予測に関するHooks
 */
export function usePrefixedWithKeywords() {
  const { apiClient } = useApiClient();

  const [prefixedWithKeywords, setPrefixedWithKeywords] = useState<string[]>(
    [],
  );

  const clearPrefixedWithKeywords = useCallback(() => {
    setPrefixedWithKeywords([]);
  }, []);

  const fetchPrefixedWithKeywords = useCallback(
    async (keyword: string) => {
      try {
        const res = await apiClient(
          `/api/search-keyword/prefixed-with?keyword=${encodeURIComponent(
            keyword,
          )}`,
          {
            method: 'GET',
          },
        );
        if (res.ok) {
          const data = await res.json();
          setPrefixedWithKeywords(data);
        } else {
          throw new Error();
        }
      } catch (e) {
        monitoring.notify({
          name: `API ERROR DETECTED ${e}`,
          message: '検索予測キーワードの取得に失敗しました。',
        });
      }
    },
    [apiClient],
  );

  return {
    prefixedWithKeywords,
    clearPrefixedWithKeywords,
    fetchPrefixedWithKeywords,
  };
}
